export default {
  ['search'](state, payload) {
    state.total = payload.total;
    state.pages = payload.pages;
    state.page = payload.page;
    state.limit = payload.limit;
    state.sortBy = payload.sortBy;
    state.sortDesc = payload.sortDesc;
    state.conditions = payload.conditions;
    state.list = payload.list;
  },

  ['loadInfo'](state, payload) {
    state.info.id = payload.id;
    state.info.status = payload.status;
    state.info.type = payload.type;
    state.info.maker = payload.maker;
    state.info.name = payload.name;
    state.info.cas_no = payload.cas_no;
    state.info.fema_no = payload.fema_no;
    state.info.pieces = payload.pieces;
    state.info.nums = payload.nums;
    state.info.synonym = payload.synonym;
    state.info.user_name = payload.user_name;
    state.info.published_at = payload.published_at;
    state.info.updated_at = payload.updated_at;
  },

  ['loadForm'](state, payload) {
    state.form.id = payload.id;
    state.form.status = payload.status;
    state.form.type = payload.type;
    state.form.maker = payload.maker;
    state.form.name = payload.name;
    state.form.cas_no = payload.cas_no;
    state.form.fema_no = payload.fema_no;
    state.form.pieces = payload.pieces;
    state.form.nums = payload.nums;
    state.form.synonym = payload.synonym;
  },

  ['clearForm'](state, payload) {
    state.form.id = null;
    state.form.status = '';
    state.form.type = 'sell';
    state.form.maker = '';
    state.form.name = '';
    state.form.cas_no = '';
    state.form.fema_no = '';
    state.form.pieces = '';
    state.form.nums = '';
    state.form.synonym = '';
  },

  ['uploads'](state, payload) {
    state.uploads = payload;
  },
};
